import { getBotMode } from 'utils/query-params'
import { useMemo } from 'react'

export const useGetBotMode = () => {
  const botMode = useMemo(() => getBotMode(), [])

  const isAppMode = botMode === 'app'

  return useMemo(() => {
    return {
      botMode,
      isAppMode: isAppMode ?? false,
      isWebMode: !isAppMode,
    }
  }, [botMode, isAppMode])
}
